import { render } from "./FootballRatingBody.vue?vue&type=template&id=9f749860&scoped=true"
import script from "./FootballRatingBody.vue?vue&type=script&lang=js"
export * from "./FootballRatingBody.vue?vue&type=script&lang=js"

import "./FootballRatingBody.vue?vue&type=style&index=0&id=9f749860&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f749860"]])

export default __exports__